module.exports = __webpack_public_path__ + "images/a2076387a48aad159ec6f1a8e5a2eb62.jpg";